export enum EBackgroundTaskEventStatus {
  
  Error = 0,
  Running,
  Finished
}